var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8462 8.53848H10.9231L9.44615 6.69233L9.12308 6.27694C8.84615 5.95386 8.47692 5.76925 8.01538 5.76925H2.84615C1.83077 5.76925 1 6.60002 1 7.6154V25.1539C1 25.7077 1.23077 26.1692 1.6 26.5385C1.64615 26.5846 1.64615 26.5846 1.69231 26.6308C2.01538 26.8616 2.43077 27 2.84615 27H26.8462C27.2615 27 27.6769 26.8616 28 26.6308C28.4154 26.3077 28.6923 25.7539 28.6923 25.1539V10.3846C28.6923 9.36925 27.8615 8.53848 26.8462 8.53848ZM8.01538 6.69233C8.15385 6.69233 8.29231 6.73848 8.38462 6.87694L10.1846 9.13848C10.3692 9.36925 10.6462 9.50771 10.9231 9.50771H26.8462C27.3538 9.50771 27.7692 9.9231 27.7692 10.4308V25.2C27.7692 25.7077 27.3538 26.1231 26.8462 26.1231H2.84615C2.33846 26.1231 1.92308 25.7077 1.92308 25.2V7.6154C1.92308 7.10771 2.33846 6.69233 2.84615 6.69233H8.01538Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6923 10.3385V24.8769C28.6923 25.4769 28.4154 25.9846 28 26.3077H1.59998V6.69231H9.44613L10.9231 8.49231H26.8461C27.8615 8.49231 28.6923 9.32308 28.6923 10.3385Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8462 9.46154C26.5693 9.46154 26.3846 9.27692 26.3846 9V4.84615C26.3846 4.33846 25.9693 3.92308 25.4616 3.92308H4.2308C3.72311 3.92308 3.30772 4.33846 3.30772 4.84615V6.23077C3.30772 6.50769 3.12311 6.69231 2.84618 6.69231C2.56926 6.69231 2.38464 6.50769 2.38464 6.23077V4.84615C2.38464 3.83077 3.21541 3 4.2308 3H25.4616C26.477 3 27.3077 3.83077 27.3077 4.84615V9C27.3077 9.27692 27.1231 9.46154 26.8462 9.46154Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66154 23.9538H4.18462C4.09231 23.9538 4 23.8615 4 23.7692V12.323C4 12.2307 4.09231 12.1384 4.18462 12.1384H5.66154C5.75385 12.1384 5.84615 12.2307 5.84615 12.323V23.7692C5.84615 23.8615 5.75385 23.9538 5.66154 23.9538Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16923 23.9539H7.69231C7.6 23.9539 7.50769 23.8616 7.50769 23.7693V15.9231C7.50769 15.8308 7.6 15.7385 7.69231 15.7385H9.16923C9.26154 15.7385 9.35384 15.8308 9.35384 15.9231V23.7693C9.35384 23.8616 9.26154 23.9539 9.16923 23.9539Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5846 17.5384V16.7538C12.5846 16.6615 12.6769 16.5692 12.7692 16.5692H25.8307C25.9231 16.5692 26.0154 16.6615 26.0154 16.7538V17.5384C26.0154 17.6307 25.9231 17.723 25.8307 17.723H12.7692C12.6769 17.723 12.5846 17.6307 12.5846 17.5384Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5846 20.677V19.8923C12.5846 19.8 12.6769 19.7077 12.7692 19.7077H25.8307C25.9231 19.7077 26.0154 19.8 26.0154 19.8923V20.677C26.0154 20.7693 25.9231 20.8616 25.8307 20.8616H12.7692C12.6769 20.8616 12.5846 20.7693 12.5846 20.677Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5846 23.7692V22.9846C12.5846 22.8923 12.6769 22.8 12.7692 22.8H25.8307C25.9231 22.8 26.0154 22.8923 26.0154 22.9846V23.7692C26.0154 23.8616 25.9231 23.9539 25.8307 23.9539H12.7692C12.6769 23.9539 12.5846 23.8616 12.5846 23.7692Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.6fcc007e581938a10f208813c5720ab2.svg";
export { ForwardRef as ReactComponent };